// JavaScript code for sn/pagination/load-more component
(($) => {

    "use strict";
    if (! $('.sn-pagination-load-more').length) {
        return;
    }
    console.log("sn/pagination/load-more scripts loaded...");

    /**
     * On click event for the load more button initiates an AJAX request to fetch more content.
     * Once the content is fetched, it appends the new content to the existing list.
     * If there are no more items to load, it hides the button.
     */
    $('.sn-pagination-load-more').on('click', 'button', async function() {
        let buttonText = $(this).text();
        let loadingSelector = $(this).data('loading-selector');
        let listSelector = $(this).data('list-selector');
        console.log("listSelector: ", listSelector);
        if (loadingSelector) {
            $(loadingSelector).show();
        }

        try {
            $(this).prop('disabled', true).text('Loading...');
            let url = $(this).data('url');
            const response = await $.get(url, null, null, 'html').promise();
            const htmlContent = $.parseHTML(response);
            const listItemsHtml = $(listSelector, htmlContent).html();
            $(listSelector).append(listItemsHtml);

            if (! $('.sn-pagination-load-more button', htmlContent).length) {
                $(this).parent('.sn-pagination-load-more').hide();
            } else {
                const nextPageUrl = $('.sn-pagination-load-more button', htmlContent).data('url');
                $(this).data('url', nextPageUrl);
            }

            $(document).trigger('sn:pagination:load-more:loaded', [htmlContent]);
        } catch (e) {
            console.error("Error disabling button: ", e);
        } finally {
            $(this).prop('disabled', false).text(buttonText);
            if (loadingSelector) {
                $(loadingSelector).hide();
            }
        }
    });

})(jQuery);